'use client';

/**
 * Framework-neutral route page-view hook for Core Analytics migrations.
 *
 * Fires once on mount and again when `metrics` or `track` identity changes. Memoize
 * `metrics`, keep `track` stable, and pass `null` on the legacy path. Pair with
 * `createAnalyticsHost` during incremental migration MRs.
 */

import { useEffect } from 'react';

/** Records one page view per route. Reads no router, so Next.js and React Router hosts share it. */
export function useTrackPageView<TMetrics>(
  track: ((metrics: TMetrics) => void) | null,
  metrics: TMetrics
): void {
  useEffect(() => {
    if (!track) {
      return;
    }

    track(metrics);
  }, [metrics, track]);
}
